import React from 'react';
import { showDialog } from '../../actions/dialog';
import { connect } from 'react-redux';
import Logger from '../../util/Logger';
import './EventCollectionDetailHeader.css';
import Collection from '../../models/Collection';
import Event from '../../models/Event';
import User from '../../models/User';
import { UserAvatar } from '../shared/UserAvatar';
import '../shared/UserAvatar.css';
import DateTime from '../../models/DateTime';
import { TopBarVisibility } from '../layout/TopBarVisibility';
import CoverImage from '../../images/creator_report_cover.svg';
import { NavigationUtils } from '../../util/NavigationUtils';
import { PresentationPageAnalytics } from '../../analytics/PresentationPageAnalytics';
import { TrackingAnalytics } from '../../analytics/TrackingAnalytics';
import { ScreenRecorder } from '../../util/ScreenRecorder';

class EventCollectionDetailHeader extends React.Component {

  constructor (props) {
    super(props);

    const { user } = props;
    if (!user) {
      Logger.assert('Missing user in EventDetailHeader component');
    }
  }


  enterPresentationMode = () => {
    PresentationPageAnalytics.enterPresentationView();
    ScreenRecorder.trackCustomAction('PRESENT_VIEW_ENTERED');
    TrackingAnalytics.gtag('Present', {
      event_id: Event.getId(this.props.event)
    });
    NavigationUtils.openTab('present');
  };

  render () {
    const { user, editing, collection } = this.props;

    const events = Collection.getEvents(collection);
    if (!events || events.length <= 0) {
      Logger.assert('Missing events in EventCollectionDetailHeader component');
    }
    const event = events[0];

    const isViewingAs = TopBarVisibility.isViewingAs(user);
    const isShowingHeroRibbon = TopBarVisibility.isShowingHeroRibbon(event);
    const isShowingConcurrentSwitcher = TopBarVisibility.isShowingConcurrentSwitcher(event,
      collection);
    const tenantName = User.hasTenant(user) ? User.getTenant(user).name : null;
    // Figure out the offset dynamically based on page content
    let offsetClass = '';
    if (isViewingAs) {
      offsetClass = 'viewing-as-and-';
      if (isShowingHeroRibbon && isShowingConcurrentSwitcher) {
        offsetClass += 'hero-ribbon-and-concurrent-switcher-offset';
      } else if (isShowingHeroRibbon) {
        offsetClass += 'hero-ribbon-offset';
      } else if (isShowingConcurrentSwitcher) {
        offsetClass += 'concurrent-switcher-offset';
      } else {
        offsetClass = '';
      }
    } else {
      if (isShowingHeroRibbon && isShowingConcurrentSwitcher) {
        offsetClass += 'hero-ribbon-and-concurrent-switcher-offset';
      } else if (isShowingHeroRibbon) {
        offsetClass += 'hero-ribbon-offset';
      } else if (isShowingConcurrentSwitcher) {
        offsetClass += 'concurrent-switcher-offset';
      } else {
        offsetClass = '';
      }
    }

    // No offset when editing mode
    if (!!editing) {
      offsetClass = '';
    }

    let title = collection ? Collection.getName(collection) : null;
    const startDate = event ? Event.getStartTime(event) : null;
    const endDate = event ? Event.getEndTime(event) : null;

    let headerClass = 'whiteout';
    if (event) {
      if (Event.isClosed(event)) {
        headerClass = 'event-detail-header-completed';
        if (User.isGuest(user)) {
          offsetClass += ' guest-offset';
        }
      } else {
        headerClass = 'event-detail-header';
      }
    }

    let coloring = 'whiteout';
    if (!!event) {
      if (Event.isClosed(event)) {
        coloring = 'whiteout';
      } else {
        coloring = 'greenout';
      }
    }

    let tz = DateTime.getCurrentTimeZone();
    const now = DateTime.applyTimeZone(DateTime.now(), tz);
    const zone = now.zoneAbbr();
    // Don't touch the formatting on this string or the visual spacing gets all messed up.
    const reportGeneratedDate = `${DateTime.format(now, 'MMM DD, YYYY', tz)} at ${DateTime.format(
      now, 'hh:mm A', tz)} ${zone}`;

    return (
      <div className={ `event-header ${offsetClass}` }>
        <div
          className={ `${headerClass}` }
          style={ { backgroundImage: `url(${CoverImage})` } }>
          <div className={ `${coloring} position-absolute` } style={{top: 0, bottom: 0, left: 0, right: 0}}>
            <div className="container">
              <div className="content">
                { !!collection && (
                  <div className="col text-left py-4">
                    <div className="row no-gutters d-print-none">
                      <div className="col">
                        <div className="list-item row no-gutters mb-3">
                          <UserAvatar user={ Event.getHero(event) } simple={ true } />
                          <div className="popin-creator ml-3">
                            { User.getDisplayName(Event.getHero(event)) }
                            &nbsp;
                            { Event.getTenantName(event) !== tenantName && `at ${Event.getTenantName(event)}` }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row no-gutters">
                      <div className="col super-hack-incoming">
                        <div className="hide-your-kids-hide-your-wife">
                          { !!title && <div className="popin-title">{ title }</div> }
                          { (!!startDate && !!endDate) && (
                            <div className="row no-gutters h-100">
                              <i className="material-icons my-auto d-print-none">access_time</i>
                              <div className="popin-date my-auto">
                                { DateTime.format(startDate, 'MMM DD, YYYY') }
                                &nbsp;-&nbsp;
                                { DateTime.format(endDate, 'MMM DD, YYYY') }
                              </div>
                              <div className="my-auto">
                                { Event.isOpen(event) && (
                                  <div className="pill-active d-print-none">
                                    ACTIVE
                                  </div>
                                ) }
                                { Event.isUpcoming(event) && (
                                  <div className="pill-upcoming d-print-none">
                                    UPCOMING
                                  </div>
                                ) }
                              </div>
                            </div>
                          ) }
                        </div>
                      </div>
                    </div>
                  </div>
                ) }
              </div>
            </div>
          </div>

          { !!event && (
            <div className="row no-gutters d-none d-print-block">
              <div className="col-4 popin-creator-print">
                <div className="popin-creator-print-content text-truncate">
                  { User.getDisplayName(Event.getHero(event)) }
                </div>
                <div className="popin-creator-print-content text-truncate">
                  { Event.getTenantName(event) }
                </div>
                <div className="popin-report-date text-truncate">
                  Exported { reportGeneratedDate }
                </div>
              </div>

              <div className="col-8" />
            </div>
          ) }

        </div>
      </div>
    );
  }

}

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user,
    event: state.event.event
  };
};

export default connect(mapStateToProps, { showDialog })(EventCollectionDetailHeader);
